import { useEffect, useState } from 'react';
import { getVendorConfig, updateVendorConfig } from '../../api/constlink';
import VendorJigjongListComponent from '../../components/enterprises/VendorJigjongListComponent';
import VendorJigjongAddModal from '../../components/enterprises/VendorJigjongAddModal';
import VendorLicenseListComponent from '../../components/enterprises/VendorLicenseListComponent';
import VendorLicenseAddModal from '../../components/enterprises/VendorLicenseAddModal';
import VendorMaterialListComponent from '../../components/enterprises/VendorMaterialListComponent';
import VendorMaterialAddModal from '../../components/enterprises/VendorMaterialAddModal';
import VendorSubcontractNameListComponent from '../../components/enterprises/VendorSubcontractNameListComponent';
import VendorSubcontractNameAddModal from '../../components/enterprises/VendorSubcontractNameAddModal';

interface VendorConfig2ContainerProps {
  enterpriseId: string;
}

function VendorConfig2Container({ enterpriseId }: VendorConfig2ContainerProps) {
  const [vendorConfig, setVendorConfig] = useState<any>();

  const [visibleVendorJigjongModal, setVisibleVendorJigjongModal] =
    useState<boolean>(false);
  const [visibleVendorLicenseModal, setVisibleVendorLicenseModal] =
    useState<boolean>(false);
  const [visibleVendorMaterialModal, setVisibleVendorMaterialModal] =
    useState<boolean>(false);
  const [
    visibleVendorSubcontractNameModal,
    setVisibleVendorSubcontractNameModal,
  ] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      const _vendorConfig = await getVendorConfig({ enterpriseId });
      setVendorConfig(_vendorConfig);
    })();
  }, [enterpriseId]);

  console.log(vendorConfig);

  const onDeleteVendorJigjong = async (name: string) => {
    const filteredData = vendorConfig.jigjongs.filter(
      (val: any) => val.name !== name,
    );
    const resVendorConfig = await updateVendorConfig({
      enterpriseId,
      data: { ...vendorConfig, jigjongs: filteredData },
    });
    setVendorConfig(resVendorConfig);
    setVisibleVendorJigjongModal(false);
  };

  const onCreateVendorJigjong = async (data: any) => {
    const _data = [...vendorConfig.jigjongs];
    _data.push(data);
    const resVendorConfig = await updateVendorConfig({
      enterpriseId,
      data: { ...vendorConfig, jigjongs: _data },
    });
    setVendorConfig(resVendorConfig);
    setVisibleVendorJigjongModal(false);
  };

  const onDeleteVendorLicense = async (name: string) => {
    const filteredData = vendorConfig.licenses.filter(
      (val: any) => val.name !== name,
    );
    const resVendorConfig = await updateVendorConfig({
      enterpriseId,
      data: { ...vendorConfig, licenses: filteredData },
    });
    setVendorConfig(resVendorConfig);
    setVisibleVendorLicenseModal(false);
  };

  const onCreateVendorLicense = async (data: any) => {
    const _data = [...vendorConfig.licenses];
    _data.push(data);
    const resVendorConfig = await updateVendorConfig({
      enterpriseId,
      data: { ...vendorConfig, licenses: _data },
    });
    setVendorConfig(resVendorConfig);
    setVisibleVendorLicenseModal(false);
  };

  const onDeleteVendorMaterial = async (name: string) => {
    const filteredData = vendorConfig.materials.filter(
      (val: any) => val.name !== name,
    );
    const resVendorConfig = await updateVendorConfig({
      enterpriseId,
      data: { ...vendorConfig, materials: filteredData },
    });
    setVendorConfig(resVendorConfig);
    setVisibleVendorMaterialModal(false);
  };

  const onCreateVendorMaterial = async (data: any) => {
    const _data = [...vendorConfig.materials];
    _data.push(data);
    const resVendorConfig = await updateVendorConfig({
      enterpriseId,
      data: { ...vendorConfig, materials: _data },
    });
    setVendorConfig(resVendorConfig);
    setVisibleVendorMaterialModal(false);
  };

  const onDeleteVendorSubcontractName = async (name: string) => {
    const filteredData = vendorConfig.subcontracts.filter(
      (val: any) => val.name !== name,
    );
    const resVendorConfig = await updateVendorConfig({
      enterpriseId,
      data: { ...vendorConfig, subcontracts: filteredData },
    });
    setVendorConfig(resVendorConfig);
    setVisibleVendorSubcontractNameModal(false);
  };

  const onCreateVendorSubcontractName = async (data: any) => {
    const _data = [...vendorConfig.subcontracts];
    _data.push(data);
    const resVendorConfig = await updateVendorConfig({
      enterpriseId,
      data: { ...vendorConfig, subcontracts: _data },
    });
    setVendorConfig(resVendorConfig);
    setVisibleVendorSubcontractNameModal(false);
  };

  return (
    <>
      {vendorConfig && (
        <VendorJigjongListComponent
          data={vendorConfig.jigjongs}
          openVendorJigjongAddModal={() => setVisibleVendorJigjongModal(true)}
          onDelete={onDeleteVendorJigjong}
        />
      )}

      {vendorConfig && (
        <VendorMaterialListComponent
          data={vendorConfig.materials}
          openVendorMaterialAddModal={() => setVisibleVendorMaterialModal(true)}
          onDelete={onDeleteVendorMaterial}
        />
      )}

      {vendorConfig && (
        <VendorSubcontractNameListComponent
          data={vendorConfig.subcontracts}
          openVendorSubcontractNameAddModal={() =>
            setVisibleVendorSubcontractNameModal(true)
          }
          onDelete={onDeleteVendorSubcontractName}
        />
      )}

      {vendorConfig && (
        <VendorLicenseListComponent
          data={vendorConfig.licenses}
          openVendorLicenseAddModal={() => setVisibleVendorLicenseModal(true)}
          onDelete={onDeleteVendorLicense}
        />
      )}

      {visibleVendorJigjongModal && vendorConfig && (
        <VendorJigjongAddModal
          visible={visibleVendorJigjongModal}
          data={vendorConfig.jigjongs}
          onCancel={() => setVisibleVendorJigjongModal(false)}
          onCreate={onCreateVendorJigjong}
        />
      )}

      {visibleVendorMaterialModal && vendorConfig && (
        <VendorMaterialAddModal
          visible={visibleVendorMaterialModal}
          data={vendorConfig.materials}
          onCancel={() => setVisibleVendorMaterialModal(false)}
          onCreate={onCreateVendorMaterial}
        />
      )}

      {visibleVendorSubcontractNameModal && vendorConfig && (
        <VendorSubcontractNameAddModal
          visible={visibleVendorSubcontractNameModal}
          data={vendorConfig.subcontracts}
          onCancel={() => setVisibleVendorSubcontractNameModal(false)}
          onCreate={onCreateVendorSubcontractName}
        />
      )}

      {visibleVendorLicenseModal && vendorConfig && (
        <VendorLicenseAddModal
          visible={visibleVendorLicenseModal}
          data={vendorConfig.licenses}
          onCancel={() => setVisibleVendorLicenseModal(false)}
          onCreate={onCreateVendorLicense}
        />
      )}
    </>
  );
}

export default VendorConfig2Container;
